import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './components/home/home.component';
import { RouterModule } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ListProjectComponent } from './components/project/list-project/list-project.component';
import { CreateProjectComponent } from './components/project/create-project/create-project.component';
import { PayPopupProjectComponent } from './components/project/pay-popup-project/pay-popup-project.component';
import { DocumentPopupProjectComponent } from './components/project/document-popup-project/document-popup-project.component';
import { CreateClientComponent } from './components/clients/create-clients/create-client.component';
import { ListClientComponent } from './components/clients/list-clients/list-client.component';
import { FrenteInformationComponent } from './components/clients/list-clients/summary-information/frente-information.component';
import { PagosJefaturaComponent } from './components/jefatura/pagos/pagos.component';
import { AuthRoutingModule } from './auth-routing.module';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ListHesComponent } from './components/finances/list-hes/list-hes.component';
import { SummaryInformationComponent } from './components/project/summary-information/summary-information.component';
import { EditDetailProjectComponent } from './components/project/edit-detail-project/edit-detail-project.component';
import { PayPopupHesComponent } from './components/finances/pay-popup-taas/pay-popup-hes.component';
import { ProjectDetailsComponent } from './components/project/project-details/project-details.component';
import { ProjectStagesComponent } from './components/project/project-stages/project-stages.component';
import { ProjectStagesCreateComponent } from './components/project/project-stages-create/project-stages-create.component';
import { RisksCreateComponent } from './components/project/risks-create/risks-create.component';
import { RisksUpdateComponent } from './components/project/risks-update/risks-update.component';
import { PopupDependencesComponent } from './components/project/project-stages/popup-dependences/popup-dependences.component';
import { WeeklyCreateComponent } from './components/project/weekly/weekly-create.component';
import { CreateMilestoneComponent } from './components/project/create-milestone/create-milestone.component';
import { UpdateMilestoneComponent } from './components/project/update-milestone/update-milestone.component';
import { IndicatorsComponent } from './components/project/project-indicators/indicators.component';
import { RiskMitigationsComponent } from './components/project/risk-mitigations/risk-mitigations.component';
import { RiskMitigationsCreateComponent } from './components/project/risk-mitigations/risk-mitigations-create/risk-mitigations-create.component';
import { RiskMitigationsUpdateComponent } from './components/project/risk-mitigations/risk-mitigations-update/risk-mitigations-update.component';
import { CreatingProjectComponent } from './components/project/creating-list-project/creating-project.component';
import { ProjectStep1Component } from './components/project/create-project/components/datos/step1-project.component';
import { ProjectStep2Component } from './components/project/create-project/components/etapas/step2-project.component';
import { ProjectStep3Component } from './components/project/create-project/components/equipo/step3-project.component';
import { Step3PopupComponent } from './components/project/create-project/components/equipo/step3-popup/step3-popup.component';
import { ProjectStep4Component } from './components/project/create-project/components/anexos/step4-project.component';
import { ProjectStep5Component } from './components/project/create-project/components/configuraciones/step5-project.component';
import { ProjectFinishAssignmentComponent } from './components/project/project-finish-assignment/project-finish-assignment.component';
import { GroupPopupProjectComponent } from './components/project/group-popup-project/group-popup-project.component';
import { ClosePopupProjectComponent } from './components/project/close-popup-project/close-popup-project.component';
import { CreatePaymentsComponent } from './components/project/payments/create-payments.component';
import { PayOnePlusOneComponent } from './components/project/payments/components/1+1/pago1+1.component';
import { PayMultiplesComponent } from './components/project/payments/components/multiples-pagos/multiplespagos.component';
import { PayEjecucionComponent } from './components/project/payments/components/ejecucion/ejecucion.component';
import { PagosPersoComponent } from './components/project/payments/components/personalizado/pagosperso.component';
import { DeletePopupProjectComponent } from './components/project/delete-popup-project/delete-popup-project.component';
import { ListPayProjectComponent } from './components/project/list-pay-project/list-pay-project.component';
import { CreatePayProjectComponent } from './components/project/create-pay-project/create-pay-project.component';
import { CreateRescheduledProjectComponent } from './components/project/create-rescheduled-project/create-rescheduled-project.component';
import { PayIntoProjectComponent } from './components/project/pay-into-project/pay-into-project.component';
import { CostEffectivenessComponent } from './components/project/cost-effectiveness/cost-effectiveness.component';
import { PayHistoryProjectComponent } from './components/project/pay-history-project/pay-history-project.component';
import { PayEditProjectComponent } from './components/project/pay-edit-project/pay-edit-project.component';
import { ProjectFinishAsignmentComponent } from './components/project/create-project/components/equipo/finish-assignament/project-finish-assignment.component';
import { EditClientComponent } from './components/clients/edit-client/edit-client.component';
import { FrenteClientComponent } from './components/clients/frente-client/frente-client.component';
import { CreateFrenteClientComponent } from './components/clients/create-frente-client/create-frente-client.component';
import { EditFrenteClientComponent } from './components/clients/edit-frente-client/edit-frente-client.component';
import { PayEditFinanceComponent } from './components/finances/pay-edit-finance/pay-edit-finance.component';
import { PayIntoFinanceComponent } from './components/finances/pay-into-finance/pay-into-finance.component';
import { ListPayComponent } from './components/finances/pay-list-finance/list-pay.component';
import { ForecastComponent } from './components/jefatura/forecast/forecast.component';
import { ForecastInformationComponent } from './components/jefatura/forecast-information/forecast-information.component';
import { ForecastDetailComponent } from './components/jefatura/forecast-detail/forecast-detail.component';
import { PendingPaymentTrainComponent } from './components/finances/pending-payment-train/pending-payment-train.component';
import { PendingPaymentTrainDetailComponent } from './components/finances/pending-payment-train-detail/pending-payment-train-detail.component';
import { ForecastPaymentTrainComponent } from './components/jefatura/forecast-payment-train/forecast-payment-train.component';
import { ForecastPaymentTrainDetailComponent } from './components/jefatura/forecast-payment-train-detail/forecast-payment-train-detail.component';
import { GeneratePayrollExcelComponent } from './components/generate-payroll-excel/generate-payroll-excel.component';

@NgModule({
  declarations: [
    LoginComponent,
    HomeComponent,
    ListHesComponent,
    ListProjectComponent,
    PayPopupHesComponent,
    CreateProjectComponent,
    PayPopupProjectComponent,
    DocumentPopupProjectComponent,
    PagosJefaturaComponent,
    ForecastDetailComponent,
    CreateClientComponent,
    ListClientComponent,
    NotFoundComponent,
    SummaryInformationComponent,
    ProjectDetailsComponent,
    EditDetailProjectComponent,
    ProjectStagesComponent,
    ProjectStagesCreateComponent,
    RisksCreateComponent,
    RisksUpdateComponent,
    PopupDependencesComponent,
    WeeklyCreateComponent,
    CreateMilestoneComponent,
    UpdateMilestoneComponent,
    IndicatorsComponent,
    RiskMitigationsComponent,
    RiskMitigationsCreateComponent,
    RiskMitigationsUpdateComponent,
    CreatingProjectComponent,
    ProjectStep1Component,
    ProjectStep2Component,
    ProjectStep3Component,
    Step3PopupComponent,
    ProjectStep4Component,
    ProjectStep5Component,
    ProjectFinishAssignmentComponent,
    GroupPopupProjectComponent,
    ClosePopupProjectComponent,
    CreatePaymentsComponent,
    PayOnePlusOneComponent,
    PayMultiplesComponent,
    PayEjecucionComponent,
    PagosPersoComponent,
    DeletePopupProjectComponent,
    ListPayProjectComponent,
    CreatePayProjectComponent,
    CreateRescheduledProjectComponent,
    PayIntoProjectComponent,
    CostEffectivenessComponent,
    PayHistoryProjectComponent,
    PayEditProjectComponent,
    ProjectFinishAsignmentComponent,
    PayHistoryProjectComponent,
    EditClientComponent,
    FrenteInformationComponent,
    FrenteClientComponent,
    CreateFrenteClientComponent,
    EditFrenteClientComponent,
    PayIntoFinanceComponent,
    PayEditFinanceComponent,
    ListPayComponent,
    ForecastComponent,
    ForecastInformationComponent,
    PendingPaymentTrainComponent,
    PendingPaymentTrainDetailComponent,
    ForecastPaymentTrainComponent,
    ForecastPaymentTrainDetailComponent,
    GeneratePayrollExcelComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    RouterModule,
    NgMultiSelectDropDownModule.forRoot(),
    DataTablesModule.forRoot()
  ],
})
export class WebModule {}
